<script>
  import { onMount } from "svelte";
  import {
    GradientCard,
    ReservationCalendar,
    Autocomplete,
    RadialChart,
    Modal,
    Button,
    AdminOnly,
    UserOnly,
    Select
  } from "../../components/index.svelte";
  import { translator, loading } from "../../store";
  import { currencyNameToSign } from "../../helpers/utils.svelte";
  import {
    getProperties,
    getPropertyReservations,
    getPropertyDashboard,
  } from "../../helpers/apiHelpers/property-management.rest.svelte";
  import IncomeChart from "../Properties/IncomeChart.svelte";
  import { MONTHS } from "../../helpers/constants.svelte";
  import MaintenanceTable from "../Properties/Maintenance/MaintenanceTable.svelte";

  let propertyList;
  let selectedProperty = null;
  let reservationCalendar = null;
  let dashboardData = null;
  let activeMonth = null;
  let activeYear = null;
  let maintenanceModalPropertyID = null;

  let showFirstLoginModal = localStorage.getItem('systemUpdateModal') != 1;

  onMount(async () => {
    $loading = true;
    propertyList = await getProperties();
    $loading = false;
    if (propertyList?.length === 1) {
      selectedProperty = propertyList[0];
      await initializeDashboardData(selectedProperty?.id);
    } else {
      propertyList.unshift({
        id: 'ALL_PROPERTIES_OF_USER-TRY',
        name: translator('Tüm Evler - TRY')
      }, {
        id: 'ALL_PROPERTIES_OF_USER-USD',
        name: translator('Tüm Evler - USD')
      })
    }
  });

  function formatMoney(number, currency) {
    let formatter = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
    });
    return formatter.format(number).replace('₺', currencyNameToSign(currency));
  }

  async function initializeDashboardData(propertyID) {
    dashboardData = await getPropertyDashboard(propertyID, activeMonth, activeYear);
    const propertyReservations = await getPropertyReservations(propertyID);
    reservationCalendar?.initializeEvents(propertyReservations);
  }

  const onCalendarDateChange = async (selectedMonth, selectedYear) => {
    activeMonth = selectedMonth;
    activeYear = selectedYear;
    initializeDashboardData(selectedProperty?.id);
  }

  const handlePropertySelect = async (e) => {
    selectedProperty = propertyList.find((i1) => i1.id === e.target.value);
    await initializeDashboardData(selectedProperty?.id);
  };
</script>
{#if propertyList?.length > 1}
  <Autocomplete
    labelField="name"
    valueField="id"
    onChange={handlePropertySelect}
    placeholder={translator("Ev seçiniz")}
    options={propertyList}
  />
{/if}
{#if selectedProperty}
  <div class="row">
    <AdminOnly>
      {#if (selectedProperty?.id).indexOf('ALL_PROPERTIES_OF_USER') != -1}
        <div class="row pt-2 pb-4">
          <div class="col-md-6">
            <Select
              onChange={(val) => onCalendarDateChange(val, activeYear)}
              placeholder={translator("Ay Seçin")}
              label={translator("Rapor Ay")}
              value={(activeMonth || (new Date()).getMonth() + 1)}
              selectOptions={[
                { text: "Ocak", value: '1'},
                { text: "Şubat", value: '2'},
                { text: "Mart", value: '3'},
                { text: "Nisan", value: '4'},
                { text: "Mayıs", value: '5'},
                { text: "Haziran", value: '6'},
                { text: "Temmuz", value: '7'},
                { text: "Ağustos", value: '8'},
                { text: "Eylül", value: '9'},
                { text: "Ekim", value: '10'},
                { text: "Kasım", value: '11'},
                { text: "Aralık", value: '12'}
              ]}
            />
          </div>
          <div class="col-md-6">
            <Select
              onChange={(val) => {onCalendarDateChange(activeMonth, val)}}
              placeholder={translator("Yıl seçin")}
              label={translator("Rapor Yıl")}
              value={parseInt((activeYear || (new Date()).getFullYear()))}
              selectOptions={[
                { text: "2022", value: '2022'},
                { text: "2023", value: '2023'},
                { text: "2024", value: '2024'}
              ]}
            />
          </div>
        </div>
      {/if}
      <div class="col-lg-4 col-md-12">
        <GradientCard
          mainTitle={`${formatMoney((dashboardData?.total_sum || 0).toFixed(2), dashboardData?.currency)}`}
          subTitle={translator("Toplam Kazanç")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="bi bi-file-arrow-down"
          gradientClass="gradient-6"
        />
      </div>
      <div class="col-lg-4 col-md-12">
        <GradientCard
          mainTitle={`${formatMoney(((dashboardData?.total_income || 0) - (dashboardData?.total_maintenance || 0)).toFixed(2), dashboardData?.currency)}`}
          subTitle={translator("Ev Sahiplerinin Kazancı")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="icon icon-wallet-90"
          gradientClass="gradient-12"
        />
      </div>
      <div class="col-lg-4 col-md-12">
        <GradientCard
          mainTitle={`${formatMoney((dashboardData?.commission_sum || 0).toFixed(2), dashboardData?.currency)}`}
          subTitle={translator("DODO Kazanç")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="bi bi-cash-stack"
          gradientClass="gradient-2"
        />
      </div>

      <!-- svelte-ignore missing-declaration -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="col-lg-4 col-md-12" on:click={ () => maintenanceModalPropertyID = selectedProperty?.id} style="cursor: pointer">
        <GradientCard
          mainTitle={`${formatMoney(dashboardData?.total_maintenance || 0, dashboardData?.currency)}`}
          subTitle={translator("Masraf Toplamı")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="icon-wrench"
          gradientClass="gradient-3"
        />
      </div>
      <div class="col-lg-4 col-md-12">
        <GradientCard
          mainTitle={`${dashboardData?.occupancy_rate || '-'}%`}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          subTitle={translator("Doluluk Oranı")}
          gradientClass="gradient-4"
        >
          <RadialChart percentage={dashboardData?.occupancy_rate || 0} color="#13ba69" />
        </GradientCard>
      </div>
      <div class="col-lg-4 col-md-12">
        <GradientCard
          mainTitle={dashboardData?.total_housekeeping_count}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          subTitle={translator("Temizlik Sayısı")}
          iconCls="las la-broom"
          gradientClass="gradient-1"
        />
      </div>
    </AdminOnly>
    <UserOnly>
      <div class="col-lg-3 col-md-12">
        <GradientCard
          mainTitle={`${formatMoney(((dashboardData?.total_income || 0) - (dashboardData?.total_maintenance || 0)).toFixed(2), dashboardData?.currency)}`}
          subTitle={translator("Net Kazanç")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="icon icon-wallet-90"
          gradientClass="gradient-2"
        />
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="col-lg-3 col-md-12 cursor-pointer" on:click={ () => maintenanceModalPropertyID = selectedProperty?.id} style="cursor: pointer">
        <GradientCard
          mainTitle={`${formatMoney(dashboardData?.total_maintenance || 0, dashboardData?.currency)}`}
          subTitle={translator("Masraf Toplamı")}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          iconCls="icon-wrench"
          gradientClass="gradient-3"
        />
      </div>
      <div class="col-lg-3 col-md-12">
        <GradientCard
          mainTitle={`${dashboardData?.occupancy_rate || '-'}%`}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          subTitle={translator("Doluluk Oranı")}
          gradientClass="gradient-4"
        >
          <RadialChart percentage={dashboardData?.occupancy_rate || 0} color="#13ba69" />
        </GradientCard>
      </div>
      <div class="col-lg-3 col-md-12">
        <GradientCard
          mainTitle={dashboardData?.total_housekeeping_count}
          info={MONTHS[dashboardData?.report_month] ? translator(`${MONTHS[dashboardData?.report_month]} ayı`) : ''}
          subTitle={translator("Temizlik Sayısı")}
          iconCls="las la-broom"
          gradientClass="gradient-1"
        />
      </div>
    </UserOnly>
  </div>
  {#if (selectedProperty?.id).indexOf('ALL_PROPERTIES_OF_USER') === -1}
    <div class="row">
      <div class="col-md-12">
        <ReservationCalendar
          onDateChange={onCalendarDateChange}
          {propertyList}
          {selectedProperty}
          bind:this={reservationCalendar}
        />
      </div>
    </div>
  {/if}
  <div class="row">
    {#key dashboardData?.currency}
      <IncomeChart propertyID={selectedProperty?.id} currency={dashboardData?.currency} />
    {/key}
  </div>
  <div class="row" />
{:else}
  <div
    class="h-100 w-100 text-center pt-5"
    style="background-color: rgba(250, 250, 250, 0.3); z-index: 2; border-radius: 30px"
  >
    <h1>{translator("Rezervasyon görüntülemek için ev seçiniz")}</h1>
  </div>
{/if}
{#if showFirstLoginModal}
<Modal
  visible={showFirstLoginModal}
  title={translator("Sistem Güncellemesi")}
  onClose={() => {
    showFirstLoginModal = false
    localStorage.setItem("systemUpdateModal", 1);
  }}
>
  <div slot="modal-body">
    <p>
      Sevgili ev sahiplerimiz, panelimizin yazılım süreci tamamlanmıştır. Yeni kullanım sürecinde bozukluklar ile karşılaşılabilir. Bir yanlışlık ya da hata ile karşılaştığınızı düşünüyorsanız lütfen sorun bildir kısmından bizlere bildirin. Değerli desteklerinizi rica ederiz
    </p>
  </div>
  <div slot="modal-footer">
    <Button
      size="sm"
      onClick={() => {
        showFirstLoginModal = false;
        localStorage.setItem("systemUpdateModal", 1);
      }}
      formName="rating-form"
      colorCls="btn-success"
    >
      {translator("Anladım")}
    </Button>
  </div>
</Modal>
{/if}
<Modal
  visible={maintenanceModalPropertyID}
  title={translator("Masraf Listesi")}
  onClose={() => {
    maintenanceModalPropertyID = null
  }}
>
<div slot="modal-body">
  {#if maintenanceModalPropertyID}
    <MaintenanceTable
      propertyID={maintenanceModalPropertyID}
      selectedMonth={dashboardData?.report_month}
      selectedYear={dashboardData?.report_year}
      tableType="dashboard-modal"
    />
  {/if}
</div>
  
</Modal>
